<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('product.addProductCard') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="product-card-add-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label>
              {{ $t('ui.file') }} (PDF):
            </label>

            <validation-provider
              rules="required"
              name="file"
              v-slot="{ errors }">
              <file-input
                :onChange="setNewFile"
                id="productCardInputFile" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="saveInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        <i v-else class="material-icons">add</i>
        {{ $t('product.addProductCard') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'product-card-new-popup',
  props: {
    productID: {
      default: 0,
      type: Number
    },
    languages: {
      default: () => ([]),
      type: Array
    },
    usedLanguageIDs: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    availableLanguages () {
      return this.languages.filter(language => this.usedLanguageIDs.indexOf(language.id) === -1);
    },
    languageOptions () {
      return this.availableLanguages.map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: null,
      file: null,
      saveInProgress: false
    };
  },
  mounted () {
    this.language = this.availableLanguages.length ? this.availableLanguages[0].id : null;
  },
  methods: {
    handleClose (newCardID = false) {
      this.$bus.$emit('product-card-new-popup-close', newCardID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['product-card-add-form'], this.saveCard);
    },
    setNewFile (event) {
      this.file = event.target.files[0];
    },
    saveCard () {
      this.saveInProgress = true;

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/products/datasheets/store',
        formData: {
          product_id: this.productID,
          language_id: this.language,
          file: this.file
        },
        successTitle: this.$t('product.addProductCardSuccessTitle'),
        successText: this.$t('product.addProductCardSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('product.addProductCardErrorText'),
        successAction: res => {
          this.saveInProgress = false;
          this.$bus.$emit('product-reload-cards');
          this.handleClose(res.id);
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      }, ['file']);
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
